import * as yup from "yup";
import { TFunction } from "i18next";

export const getYupSchemaForGrRatingForm = (t: TFunction) => {
  return yup.object().shape({
    number: yup
      .number()
      .nullable()
      .typeError(t("validation.numeric_field"))
      .integer(t("validation.integer"))
      .min(0, t("validation.negative_area")),
    name: yup
      .string()
      .max(250, t("validation.more250"))
      .required(t("validation.required")),
    nameEn: yup
      .string()
      .max(250, t("validation.more250"))
      .required(t("validation.required")),
    yearPercent: yup.object().shape({
      label: yup
        .string()
        .min(1, t("validation.more250"))
        .required(t("validation.required")),
      value: yup.string().nullable().required(t("validation.required")),
    }),
    yearValue: yup.object().shape({
      label: yup
        .string()
        .min(1, t("validation.more250"))
        .required(t("validation.required")),
      value: yup.string().nullable().required(t("validation.required")),
    }),
    quarter1: yup.object().shape({
      label: yup
        .string()
        .min(1, t("validation.more250"))
        .required(t("validation.required")),
      value: yup.string().nullable().required(t("validation.required")),
    }),
    quarter2: yup.object().shape({
      label: yup
        .string()
        .min(1, t("validation.more250"))
        .required(t("validation.required")),
      value: yup.string().nullable().required(t("validation.required")),
    }),
    quarter1_2: yup.object().shape({
      label: yup
        .string()
        .min(1, t("validation.more250"))
        .required(t("validation.required")),
      value: yup.string().nullable().required(t("validation.required")),
    }),
    quarter3: yup.object().shape({
      label: yup
        .string()
        .min(1, t("validation.more250"))
        .required(t("validation.required")),
      value: yup.string().nullable().required(t("validation.required")),
    }),
    quarter2_3: yup.object().shape({
      label: yup
        .string()
        .min(1, t("validation.more250"))
        .required(t("validation.required")),
      value: yup.string().nullable().required(t("validation.required")),
    }),
    quarter4: yup.object().shape({
      label: yup
        .string()
        .min(1, t("validation.more250"))
        .required(t("validation.required")),
      value: yup.string().nullable().required(t("validation.required")),
    }),
    quarter3_4: yup.object().shape({
      label: yup
        .string()
        .min(1, t("validation.more250"))
        .required(t("validation.required")),
      value: yup.string().nullable().required(t("validation.required")),
    }),
    sort: yup
      .number()
      .typeError(t("validation.numeric_field"))
      .integer(t("validation.integer"))
      .required(t("validation.required"))
      .min(0, t("validation.negative_area")),
    format: yup
      .number()
      .typeError(t("validation.numeric_field"))
      .integer(t("validation.integer"))
      .min(0, t("validation.negative_area")),
    round: yup
      .number()
      .typeError(t("validation.numeric_field"))
      .integer(t("validation.integer"))
      .min(0, t("validation.negative_area")),
  });
};
